var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure-box"},[_c('HeaderNav',{attrs:{"header-title":"按趋势","left-icon-name":"2","right-icon-name":"3"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure-box-content"},[_c('div',{attrs:{"id":"main"}}),_c('div',{staticClass:"zhanwei"}),_c('div',{attrs:{"id":"mainOne"}}),_c('div',{staticClass:"zhanwei",staticStyle:{"margin-bottom":"30rpx"}})])
}]

export { render, staticRenderFns }